import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../app/api";
import FormField1 from "../../components/FormField";
import Loader from "../../components/Loader";
import Screen from "../../components/Screen";
import SubmitButton from "../../components/SubmitButton";
import useAlert from "../../hooks/useAlert";
import { Box } from "@mui/material";
import ReactQuill from "react-quill";
import { keys } from "../../config/keys";
import useAuth from "../../hooks/useAuth";
export default function Default() {
    const navigate = useNavigate()
    const [loading, setloading] = useState(null)
    const [data, setData] = useState({
        validity: "",
        allowedInbox: "",
        companyID: "",
        additionalFeatures: [
            {
                feature: "",
                allocation: "",
            },
        ],
    })
    const {isCompanyAdmin, isFellowAdmin} = useAuth()
    const location = useLocation()
    const { showAlert } = useAlert()
    const onAddProposal = async (dontSendMail) => {
        setloading(dontSendMail ? "copy":"new")
        try {
            const response = await api.post(
                `/proposal/add`,
                { ...data, name: "custom-" + data.name, ...(dontSendMail ? {dontSendMail}:{}) }
            );
            if (response.data.status) {
                showAlert(dontSendMail ? "Link copies to clipboard":response.data.message, "success")
                if(dontSendMail){
                    await navigator.clipboard.writeText(`${keys.BASE_LOCAL_URL}/${response.data.result.pdfLink}`);
                }
                navigate("/list-Proposal")
            } else {
                showAlert(response.data.message, "danger")
            }
        } catch (error) {
            showAlert(error.message, "danger")
        } finally {
            setloading(null)
        }
    }
    let fields = [
        {
            value: data?.proposalFor,
            setValue: (value) => setData({ ...data, proposalFor: value }),
            label: "Proposal for",
            placeholder: "Proposal for",
            required: true,
            options: [
                {
                    name: "Company",
                    value: "company",
                },
                ...((!isCompanyAdmin && !isFellowAdmin) ? [{
                    name: "Admin",
                    value: "admin",
                }] :[])
            ].filter(it=>it),
            type: "dropdown",
            id: "proposalFor",
        },
        {
            value: data?.proposalName,
            setValue: (value) => setData({ ...data, proposalName: value }),
            label: "Enter proposal name",
            placeholder: "Enter proposal name",
            type: "text",
            id: "proposalName",
            required: true,
        },
        {
            value: data?.name,
            setValue: (value) => setData({ ...data, name: value }),
            label: "Enter subscription name",
            placeholder: "Enter subscription name",
            type: "text",
            id: "name",
            required: true,
        },
        {
            value: data?.cost,
            setValue: (value) => setData({ ...data, cost: value }),
            label: "Enter cost",
            placeholder: "Enter cost",
            type: "number",
            required: true,
            id: "cost",
        },
        ...(data.proposalFor != 'admin' ? [{
            value: data?.allowedChecklists,
            setValue: (value) => setData({ ...data, allowedChecklists: value }),
            label: "Enter checklists",
            placeholder: "Enter checklists",
            type: "number",
            required: true,
            id: "allowedChecklists",
            required: true,
        },
        {
            value: data?.allowedAudit,
            setValue: (value) => setData({ ...data, allowedAudit: value }),
            label: "Enter audits",
            placeholder: "Enter audits",
            type: "number",
            required: true,
            id: "allowedAudit",
        },
        {
            value: data?.allowedPolicies,
            setValue: (value) => setData({ ...data, allowedPolicies: value }),
            label: "Enter policies",
            placeholder: "Enter policies",
            type: "number",
            required: true,
            id: "allowedPolicies",
        },
        {
            value: data?.allowedRiskAssessments,
            setValue: (value) => setData({ ...data, allowedRiskAssessments: value }),
            label: "Enter risk assessments",
            placeholder: "Enter risk assessments",
            type: "number",
            required: true,
            id: "allowedRiskAssessments",
        },
        {
            value: data?.allowedForms,
            setValue: (value) => setData({ ...data, allowedForms: value }),
            label: "Enter forms",
            placeholder: "Enter forms",
            type: "number",
            required: true,
            id: "allowedForms",
        },
        {
            value: data?.allowedAgreements,
            setValue: (value) => setData({ ...data, allowedAgreements: value }),
            label: "Enter agreements",
            placeholder: "Enter agreements",
            type: "number",
            required: true,
            id: "allowedAgreements",
        },
        {
            value: data?.allowedTasksPerDay,
            setValue: (value) => setData({ ...data, allowedTasksPerDay: value }),
            label: "Enter task submissions per day",
            placeholder: "Enter task submissions per day",
            type: "number",
            required: true,
            id: "allowedTasksPerDay",
        },
        {
            value: data?.allowedDocuments,
            setValue: (value) => setData({ ...data, allowedDocuments: value }),
            label: "Enter documents",
            placeholder: "Enter documents",
            type: "number",
            required: true,
            id: "allowedDocuments",
        },
        {
            value: data?.allowedGroups,
            setValue: (value) => setData({ ...data, allowedGroups: value }),
            label: "Enter email groups",
            placeholder: "Enter email groups",
            type: "number",
            required: true,
            id: "allowedGroups",
        },
        {
            value: data?.allowedEmails,
            setValue: (value) => setData({ ...data, allowedEmails: value }),
            label: "Enter email recipients",
            placeholder: "Enter email recipients",
            type: "number",
            required: true,
            id: "allowedEmails",
        },
        {
            value: data?.allowedSharePerDay,
            setValue: (value) => setData({ ...data, allowedSharePerDay: value }),
            label: "Enter email shares per day",
            placeholder: "Enter email shares per day",
            type: "number",
            required: true,
            id: "allowedSharePerDay",
        },
        {
            value: data?.allowedInbox,
            setValue: (value) =>
                setData({ ...data, allowedInbox: value == "true" ? true : false }),
            label: "Is inbox allowed",
            placeholder: "Is inbox allowed",
            type: "dropdown",
            options: [
                {
                    name: "True",
                    value: "true",
                },
                {
                    name: "False",
                    value: "false",
                },
            ],
            id: "allowedInbox",
            required: true,
        },
        {
            value: data?.allowedEmployees,
            setValue: (value) => setData({ ...data, allowedEmployees: value }),
            label: "Enter Managers/supervisors/guest accounts",
            placeholder: "Enter Managers/supervisors/guest accounts",
            type: "number",
            required: true,
            id: "allowedEmployees",
        },
        {
            value: data?.additionalSites,
            setValue: (value) => setData({ ...data, additionalSites: value }),
            label: "Enter additional sites",
            placeholder: "Enter additional sites",
            type: "number",
            required: true,
            id: "additionalSites",
        }] : []),
        {
            value: data?.validity,
            setValue: (value) => setData({ ...data, validity: value }),
            label: "Select validity",
            placeholder: "Select validity",
            required: true,
            options: [
                {
                    name: "Monthly",
                    value: "monthly",
                },
                {
                    name: "Yearly",
                    value: "yearly",
                },
            ],
            type: "dropdown",
            id: "validity",
        },
        data.proposalFor == 'company' && {
            value: data?.companyEmail,
            setValue: (value) => setData({ ...data, companyEmail: value }),
            label: 'Enter company email',
            placeholder: 'Enter company email',
            type: 'email',
            id: 'companyEmail',
            required: true
        },
        data.proposalFor == 'admin' && {
            value: data?.adminEmail,
            setValue: (value) => setData({ ...data, adminEmail: value }),
            label: 'Enter admin email',
            placeholder: 'Enter admin email',
            type: 'email',
            id: 'adminEmail',
            required: true
        },
        {
            value: data?.emailText,
            setValue: (value) => setData({ ...data, emailText: value }),
            label: 'Enter text for email',
            placeholder: 'Enter text for email',
            type: 'longtext',
            id: 'emailText',
            required: true
        },
        {
            value: data?.proposalText,
            setValue: (value) => setData({ ...data, proposalText: value }),
            label: 'Enter text for proposal',
            placeholder: 'Enter text for proposal',
            type: 'styleText',
            onChange:(value)=>setData({ ...data, proposalText: value }),
            id: 'proposalText',
            required: true
        },
    ].filter(it => it);
    useEffect(() => {
        if (location.state) {
            setData(location.state)
        }
    }, []);
    return (
        <Screen
            loading={loading == 'initial'}
            flow={[
                { label: `Create Proposal`, to: `/add-proposal` },
                { label: "Home", to: "/checklists" },
                { label: `Create Proposal`, to: `/add-proposal` },
            ]}
        >
            <>
                <div className="card gap-3 py-4">

                    <div className="card-body">
                        {fields.map((item) => (
                            <div className="col-12">
                                <FormField field={item} />
                            </div>
                        ))}
                        {data.additionalFeatures?.map((item, index) => (
                            <div className='row mt-2'>
                                <div className='col-6'>
                                    <FormField1
                                        item={{
                                            value: item?.feature,
                                            setValue: (value) => setData(prevState => {
                                                let newState = { ...prevState }
                                                newState.additionalFeatures[index].feature = value
                                                return newState
                                            }),
                                            placeholder: 'Enter feature name',
                                            type: 'text',
                                            required: true,
                                            id: `feature-${index}`,
                                            className: ""
                                        }}
                                    />
                                </div>
                                <div className='col-5'>
                                    <FormField1
                                        item={{
                                            value: item?.allocation,
                                            setValue: (value) => setData(prevState => {
                                                let newState = { ...prevState }
                                                newState.additionalFeatures[index].allocation = value
                                                return newState
                                            }),
                                            placeholder: 'Enter allocation',
                                            type: 'text',
                                            required: true,
                                            id: `allocation-${index}`,
                                            className: ""
                                        }}
                                    />
                                </div>
                                <div className='col-1'>
                                    <SubmitButton
                                        icon={<i className="bi bi-trash3"></i>}
                                        loading={loading == "delete"}
                                        onClick={() => {
                                            setData(prevState => {
                                                let newState = { ...prevState }
                                                newState.additionalFeatures.splice(index, 1)
                                                return newState
                                            })
                                        }}
                                        color={"danger"}
                                        loaderColor={"white"}
                                    // disabled={disabled}
                                    />
                                </div>
                            </div>
                        ))}
                        <div className='col-12'>
                            <div className='col-6 col-sm-6 col-md-6 col-lg-12'>
                                <button
                                    className='btn btn-sm rounded-5 btn-outline-primary w-100 mt-2'
                                    onClick={() => {
                                        setData(prevState => {
                                            let newState = { ...prevState }
                                            newState.additionalFeatures.push({
                                                feature: '',
                                                allocation: ""
                                            })
                                            return newState
                                        })
                                    }}
                                >
                                    <Loader center color={'white'}>
                                        Add More +
                                    </Loader>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mt-4 gap-2">
                        <SubmitButton
                            title={"Add Proposal"}
                            loading={loading == "new"}
                            onClick={() => {
                                onAddProposal();
                            }}
                            color={"success"}
                            loaderColor={"white"}
                            disabled={
                                data.name == "" ||
                                data.cost == "" ||
                                data.allowedChecklists == "" ||
                                data.allowedAudit == "" ||
                                data.allowedPolicies == "" ||
                                data.allowedRiskAssessments == "" ||
                                data.allowedEmployees == "" ||
                                data.allowedTasksPerDay == "" ||
                                data.allowedDocuments == "" ||
                                data.allowedGroups == "" ||
                                data.allowedEmails == "" ||
                                data.allowedSharePerDay == "" ||
                                (data.allowedInbox != true && data.allowedInbox != false) ||
                                data.additionalSites == "" ||
                                data.validity == "" ||
                                loading =="copy"
                            }
                        />
                        <SubmitButton
                            title={"Get Proposal Link"}
                            loading={loading == "copy"}
                            onClick={() => {
                                onAddProposal(true);
                            }}
                            color={"success"}
                            loaderColor={"white"}
                            disabled={
                                data.name == "" ||
                                data.cost == "" ||
                                data.allowedChecklists == "" ||
                                data.allowedAudit == "" ||
                                data.allowedPolicies == "" ||
                                data.allowedRiskAssessments == "" ||
                                data.allowedEmployees == "" ||
                                data.allowedTasksPerDay == "" ||
                                data.allowedDocuments == "" ||
                                data.allowedGroups == "" ||
                                data.allowedEmails == "" ||
                                data.allowedSharePerDay == "" ||
                                (data.allowedInbox != true && data.allowedInbox != false) ||
                                data.additionalSites == "" ||
                                data.validity == "" ||
                                loading =="copy"
                            }
                        />
                    </div>
                </div>


            </>
        </Screen>
    );
}

const FormField = ({ field }) => {
    const onChange = (e) => field.setValue(e.target.value);
    const modules = {
        // toolbar: [[{ header: [1, 2, false] }], ["bold"]],
        toolbar: [
            [{ header: [1, 2, false] }], // Dropdown for header formatting
            ["bold", "italic", "underline", "strike"], // Text styles
            [{ list: "ordered" }, { list: "bullet" }], // Lists
            ["link"], // Media insertion
        ],
      };
    
      const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "link",
        "image",
      ];
    return (
        <div className="row mb-3">
            <label htmlFor={field.id} className="col-md-4 col-lg-3 col-form-label">
                {field.label}
                {field.required ? <span className="text-danger"> *</span> : null}
            </label>
            <div className="col-md-8 col-lg-9">
                {field.type == "longtext" ? (
                    <textarea
                        name={field.id}
                        className="form-control"
                        id={field.id}
                        style={{ height: 100 }}
                        onChange={onChange}
                        value={field.value}
                    />
                )
                    : field.type == "dropdown" ? (
                        <>
                            <select
                                id={field.id}
                                value={field.value}
                                className="form-select"
                                onChange={onChange}
                            >
                                <option
                                    selected={
                                        field?.value == "" ||
                                        field.value == null ||
                                        field.value == undefined
                                    }
                                    value={""}
                                >
                                    {`-- ${field.placeholder} --`}
                                </option>
                                {field?.options?.map((val, index) => {
                                    const value = !val.value ? val._id : val.value;
                                    const display = !!val.name ? val.name : val;
                                    return (
                                        <option
                                            key={index}
                                            selected={field?.value == value}
                                            value={value}
                                        >
                                            {display}
                                        </option>
                                    );
                                })}
                            </select>
                        </>
                    )
                        : field.type == "styleText" ? (
                            <>
                                <Box
                                    sx={{
                                        height: "580px",
                                    }}
                                >
                                    <ReactQuill
                                        style={{
                                            height: "500px",
                                        }}
                                        value={field.value}
                                        onChange={field.onChange}
                                        modules={modules}
                                        formats={formats}
                                        theme="snow"
                                    />
                                </Box>
                            </>
                        )
                            : (
                                <input
                                    name={field.id}
                                    type={field.type}
                                    className="form-control"
                                    id={field.id}
                                    value={field.value}
                                    onChange={onChange}
                                    placeholder={field.placeholder}
                                />
                            )}
            </div>
        </div>
    );
};
